import { useField } from 'formik';
import { FC, ReactNode } from 'react';
import { inputClass } from 'shared/theme/colorTokens';
import FormField from './FormField';

interface FormikInputProps {
  name: string;
  label?: ReactNode;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
  /** Renderiza un `<textarea>` en vez de un `<input>`. */
  multiline?: boolean;
  rows?: number;
  className?: string;
}

/**
 * Input de texto de Formik con el estilo estándar: label, control y error
 * (se muestra solo si el campo fue tocado). Soporta nombres anidados
 * (`referents.0.name`).
 */
const FormikInput: FC<FormikInputProps> = ({
  name,
  label,
  multiline = false,
  rows,
  className,
  ...inputProps
}) => {
  const [field, meta] = useField(name);

  return (
    <FormField
      label={label}
      htmlFor={name}
      error={meta.touched && meta.error}
      className={className}
    >
      {multiline ? (
        <textarea
          id={name}
          rows={rows}
          className={inputClass}
          {...field}
          {...inputProps}
        />
      ) : (
        <input id={name} className={inputClass} {...field} {...inputProps} />
      )}
    </FormField>
  );
};

export default FormikInput;
